// extracted by mini-css-extract-plugin
module.exports = {"root":"Stack_root__1MrSZ"};